import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import './CitizenCardIssueBar.css';

const DEFAULT_MESSAGE = 'Your citizen card appears inactive or expired. Please contact Registry at 807-623-4635.';

const CitizenCardIssueBar = () => {
  const { currentUser } = useContext(AuthContext);

  if (!currentUser?.cardIssueFlag) return null;

  const message = currentUser.cardIssueMessage || DEFAULT_MESSAGE;

  return (
    <div className="citizen-card-issue-bar" role="alert" aria-live="polite">
      <span className="citizen-card-issue-label">Citizen Card Notice:</span>
      <span className="citizen-card-issue-text">{message}</span>
    </div>
  );
};

export default CitizenCardIssueBar;
